module.exports = __webpack_public_path__ + "static/image2-7560c383eccfa515ea12081c3e34bf66.jpg";